import type { MouseEvent, ReactNode } from "react";
import { APP_STORE_URL } from "../lib/seo";

export default function OpenInAppLink({ href, className, children }: { href: string; className?: string; children: ReactNode }) {
  function open(event: MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    const started = Date.now();
    window.location.assign(href);
    window.setTimeout(() => {
      if (document.visibilityState === "visible" && Date.now() - started < 2500) {
        window.location.assign(APP_STORE_URL);
      }
    }, 1200);
  }

  return <a href={href} className={className} onClick={open}>{children}</a>;
}
